const RedPin = () => {
	return (
		<svg
			width="28"
			height="33"
			viewBox="0 0 28 33"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M23.4595 3.99629C20.9538 1.49697 17.5555 0.0918987 14.0114 0.089846C10.4672 0.0877933 7.06729 1.48893 4.55866 3.98534C2.05003 6.48175 0.637988 9.86919 0.632827 13.4032C0.627665 16.9373 2.02981 20.3288 4.53113 22.8325L13.0399 31.6797C13.1647 31.8094 13.3145 31.9126 13.4803 31.983C13.6461 32.0535 13.8245 32.0898 14.0048 32.0898C14.1851 32.0898 14.3634 32.0535 14.5293 31.983C14.6951 31.9126 14.8449 31.8094 14.9697 31.6797L23.4595 22.8521C25.9635 20.3498 27.3698 16.9591 27.3698 13.4242C27.3698 9.8892 25.9635 6.49859 23.4595 3.99629Z"
				fill="#FA566A"
			/>
			<path
				d="M14.0026 16.8518C15.8777 16.8518 17.3978 15.3167 17.3978 13.4232C17.3978 11.5297 15.8777 9.99463 14.0026 9.99463C12.1275 9.99463 10.6074 11.5297 10.6074 13.4232C10.6074 15.3167 12.1275 16.8518 14.0026 16.8518Z"
				fill="white"
			/>
		</svg>
	);
};

export default RedPin;
